// Imagekit constants
export const urlEndpoint = 'https://ik.imagekit.io/ppzdej5w6i0/';
